import axios from 'axios'

export default {
  getChats(context) {
    axios.get('support_chats').then((res) =>
      context.commit(
        'setChats',
        res.data.data.map((el) => ({
          ago_time: el.ago_time,
          created_at: el.created_at,
          id: el.id,
          is_read: el.messages[0].is_read,
          messages: el.messages,
          owner: el.user,
          online: false,
          last_message_created_at: el.messages[0].sent_on,
          last_message_created: new Date(el.messages[0].sent_on).getTime(),
        })),
      ),
    )
  },
}
